<template>
	<div>
    <div id="faktur-gaji">
        <div class="vh-100" id="FakturGaji">

            <!-- HEADER -->
            <div class="header-top bg-white">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left" @click="backtobayargaji">
                        <div class="header-item">
                            <img src="../../../assets/icons/back-blue.svg" alt="a">
                        </div>
                    </div>
                    <div class="header-top--middle f-cont f-16 f-bold">Faktur Gaji</div>
                    <div class="header-top--right">
                        <div class="header-item">
                            <!--                            <img src="../../../assets/icons/preview-faktur.svg" alt="a">-->
                        </div>
                    </div>
                </div>
            </div>

            <!-- CONTENT -->
            <div class="content-wrapper main-page">
                <div class="p-y-16 p-x-20 w-limit">
                    <div class="f-18 f-bold">{{datafakturgaji.nama_karyawan_Faktur}}</div>
                    <div class="m-t-4 f-14 f-c-midgrey">{{datafakturgaji.periode_format_Faktur}}</div>
                </div>
                <div class="separator-line-dot w-limit"></div>

<!--                <div class="p-x-20 p-y-16 d-flex justify-content-between w-limit" >
                    <div class="f-14 f-c-midgrey detail-absensi">
                        <div class="text-nowrap"><b>Masuk</b> {{datafakturgaji.masuk_kerja_Faktur}} hr</div>
                        <div class="text-nowrap"><b>Tdk masuk</b> {{datafakturgaji.Alpha_Faktur}} hr</div>
                        <div class="text-nowrap" v-if="datadetailabsen.durasi_keterlambatan.raw >0"><b>Terlambat</b>
                            {{newrupiahcreateepaymentnominal(datadetailabsen.durasi_keterlambatan.raw)}} mnt
                        </div>
                        <div class="text-nowrap" v-else><b>Terlambat</b> 0 mnt</div>
                    </div>
                    <div class="f-14 f-semi f-c-blue text-nowrap" @click="gotodetailehadiran">Lihat Detail</div>
                </div>-->
                <div class="p-x-20 p-y-16 d-flex justify-content-between w-limit">
                    <div class="f-14 f-c-midgrey detail-absensi">
                        <div class="text-nowrap"><b>Masuk</b> {{datafakturgaji.masuk_kerja_Faktur}} hr</div>

                        <div class="text-nowrap" v-if="datadetailabsen.durasi_keterlambatan.raw >0"><b>Terlambat</b>
                            {{newrupiahcreateepaymentnominal(datadetailabsen.durasi_keterlambatan.raw)}} mnt
                        </div>
                        <div class="text-nowrap" v-else><b>Terlambat</b> 0 mnt</div>
                    </div>
                    <div class="f-14 f-semi f-c-blue text-nowrap" @click="editBayarTerlambat(true)">Edit Kehadiran</div>
                </div>

                <div class="separator"></div>

                <!-- GAJI -->
                <div class="p-y-16 p-x-20 w-limit">
                    <div class="f-16 f-bold">Gaji</div>
                    <div class="m-t-10 item-gaji--wrapper">

                        <div class="item-gaji d-flex justify-content-between align-items-center"
                             v-for="(ListGaji, index) in DataGajiFaktur" :key="ListGaji.id"
                             @click="editGajiFaktur(ListGaji, index)">
                            <div class="item-gaji--left">
                                <div class="f-14" v-bind:for="ListGaji.id">{{ListGaji.text}}</div>
                                <div class="f-12 f-c-midgrey" v-if="ListGaji.type===1">{{ListGaji.nominal | currency}} x
                                    1 Periode
                                </div>
                                <div class="f-12 f-c-midgrey" v-else-if="ListGaji.type===2">{{ListGaji.nominal |
                                    currency}} x
                                    {{datafakturgaji.masuk_kerja_Faktur}} Hadir
                                </div>
                                <div class="f-12 f-c-midgrey" v-else>{{ListGaji.nominal | currency}} x
                                    {{ListGaji.periode}} Jam
                                </div>
                            </div>
                            <div class="item-gaji--right d-flex">
                                <div class="f-14 m-r-12" v-if="ListGaji.type===1">{{ListGaji.nominal | currency}}</div>
                                <div class="f-14 m-r-12" v-if="ListGaji.type===2">
                                    {{ListGaji.nominal*datafakturgaji.masuk_kerja_Faktur | currency}}
                                </div>
                                <div class="f-14 m-r-12" v-if="ListGaji.type===3">
                                    {{ListGaji.nominal*ListGaji.periode | currency}}
                                </div>
                                <img src="../../../assets/icons/edit-20.svg" alt="a">
                            </div>
                        </div>

                        <div class="separator-line-dot m-t-10"></div>

                        <div class="m-t-16 f-16 f-semi d-flex justify-content-between">
                            <div>Subtotal Gaji</div>
                            <div>{{subtotalGaji | currency}}</div>
                        </div>
                    </div>

                </div>

                <div v-if="dataUpahTahapan.length===0">
                    <div class="separator"></div>
                    <div class="w-limit">
                        <div class="p-x-20 p-y-16 d-flex-between-center align-items-center">
                            <div class="f-16 f-bold">Upah Borongan</div>
                            <div class="f-semi f-14 f-c-blue" @click="lihatDetailUpahBorongan">Lihat detail</div>
                        </div>
                        <div class="p-x-20 p-d-16 f-reguler f-14 f-c-midgrey">Data upah borongan tidak ditemukan</div>
                    </div>
                </div>

                <div v-if="dataUpahTahapan.length>0">
                    <div class="separator"></div>

                    <!-- Upah BORONGAN -->
                    <div class="w-limit">
                        <div class="p-x-20 p-y-16 d-flex-between-center align-items-center">
                            <div class="f-16 f-bold">Upah Borongan</div>
	                        <div class="f-semi f-14 f-c-blue" @click="lihatDetailUpahBorongan">Lihat detail</div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="p-x-20 item-komisi--wrapper">

                            <div class="item-komisi d-flex justify-content-between align-items-start"
                                 v-for="ListUpah in dataUpahTahapan">
                                <div class="item-komisi--left">
                                    <div class="f-14">{{ListUpah.nama_tahapan}}</div>
                                    <div class="f-12 f-c-midgrey">Dari
                                        {{newrupiahcreateepaymentnominal(ListUpah.kauntitas_tahapan)}}
                                        layanan
                                    </div>
                                </div>
                                <div class="item-komisi--right d-flex p-l-20">
                                    <div class="f-14 m-r-12">{{ListUpah.total_gaji | currency }}</div>
                                    <img src="../../../assets/icons/circle-blue-disabled.svg" alt="a">
                                </div>
                            </div>

                            <div class="separator-line-dot m-t-10"></div>

                            <div class="p-y-16 f-16 f-semi d-flex justify-content-between">
                                <div>Subtotal Upah</div>
                                <div>{{subtotalUpahTahapn | currency}}</div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="separator"></div>

                <!-- KOMISI -->
                <div class="w-limit">
                    <div class="p-x-20 p-y-16">
                        <div class="f-16 f-bold">Komisi</div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="p-y-16 p-x-20 d-flex hov align-items-center" @click="addKomisiCustom">
                        <img src="../../../assets/icons/circle_add.svg" alt="">
                        <div class="f-14 f-semi f-c-blue m-l-8">Tambah komisi lain...</div>
                    </div>

                    <div class="p-x-20 item-komisi--wrapper">

                        <div class="item-komisi d-flex justify-content-between align-items-start">
                            <div class="item-komisi--left">
                                <div class="f-14">{{komisiSales.nama_komisi}}</div>
                                <div class="f-12 f-c-midgrey">{{komisiSales.jenis_komisi}}</div>
                            </div>
                            <div class="item-komisi--right d-flex p-l-20" v-if="komisiSales.komisi>0">
                                <div class="f-14 m-r-12">{{komisiSales.komisi | currency}}</div>
                                <img src="../../../assets/icons/circle-blue-disabled.svg" alt="a">
                            </div>
                        </div>
                        <div class="item-komisi d-flex justify-content-between align-items-start"
                             @click="editKomisiCustom(idx,komisiCustom)" v-for="(komisiCustom,idx) in dataKomisiCustom">
                            <div class="item-komisi--left">
                                <div class="f-14">{{komisiCustom.nama}}</div>
                            </div>
                            <div class="item-komisi--right d-flex p-l-20">
                                <div class="f-14 m-r-12">{{komisiCustom.nominal.raw | currency}}</div>
                                <img src="../../../assets/icons/edit-20.svg" alt="a"
                                >
                            </div>
                        </div>

                        <div class="separator-line-dot m-t-10"></div>

                        <div class="p-y-16 f-16 f-semi d-flex justify-content-between">
                            <div>Subtotal Komisi</div>
                            <div>{{subtotalKomisi | currency }}</div>
                        </div>

                    </div>
                </div>

                <div class="separator"></div>
                <!-- TOTAL GAJI BERSIH -->
                <div class="m-t-16 p-x-20 w-limit">
                    <div class="f-16 f-bold d-flex justify-content-between f-c-green">
                        <div class="d-flex">
                            <div>Total Gaji Kotor</div>
                            <!--                            <img class="m-l-4" src="../../../assets/icons/ic" alt="">-->
                        </div>
                        <div>{{ totalGajiKotor | currency }}</div>
                    </div>
                    <div class="f-12 f-c-midgrey m-t-8">
                        Gaji karyawan yang belum dikurangi potongan
                    </div>
                </div>

                <div class="separator"></div>


                <div class="w-limit">
                    <div class="p-x-20 p-y-16">
                        <div class="f-16 f-bold">Tanggungan</div>
                        <div class="f-12 f-c-midgrey" v-if="nominal_tanggungan>0">Karyawan ini memiliki tanggungan {{
                            nominal_tanggungan | currency }}
                        </div>
                    </div>
                    <div class="separator-line"></div>

                    <div class="p-y-16 p-x-20 d-flex hov align-items-center" @click="gosettanggungan"
                         v-if="nominal_tanggungan>0">
                        <img src="../../../assets/icons/circle_add.svg" alt="">
                        <div class="f-14 f-semi f-c-blue m-l-8">Tambah pembayaran
                            tanggungan...
                        </div>
                    </div>
                    <div class="p-x-20 item-tanggungan--wrapper"
                    >
                        <div class="item-tanggungan d-flex justify-content-between align-items-center"
                             v-if="datadetailabsen.durasi_keterlambatan.raw>0"
                             @click="editBayarTerlambat(false)">
                            <div class="item-tanggungan--left">
                                <div class="f-14">Denda Keterlambatan</div>
                                <div class="f-12 f-c-midgrey">Terlambat
                                    {{newrupiahcreateepaymentnominal(datadetailabsen.durasi_keterlambatan.raw)}} Menit
                                </div>
                            </div>
                            <div class="item-tanggungan--right d-flex align-items-center">
                                <div class="f-14 m-r-12 f-c-red">
                                    {{datadetailabsen.nominal_keterlambatan.raw | currency }}
                                </div>
                                <img src="../../../assets/icons/edit-red.svg" alt="a">
                            </div>
                        </div>
                        <div class="item-tanggungan d-flex justify-content-between align-items-center"
                             v-for="(tanggunganpotongan,idx) in datalisttanggungan.pembayaran_potongan"
                             @click="editBayarPotongan(idx,tanggunganpotongan)">
                            <div class="item-tanggungan--left">
                                <div class="f-14">{{tanggunganpotongan.potongan.keterangan}}</div>

                                <div class="f-12 f-c-midgrey">Potongan • Rp
                                    {{tanggunganpotongan.potongan.saldo | currency }}
                                </div>
                            </div>
                            <div class="item-tanggungan--right d-flex align-items-center">
                                <div class="f-14 m-r-12 f-c-red">
                                    {{tanggunganpotongan.nominal.raw | currency}}
                                </div>
                                <img src="../../../assets/icons/edit_red.svg" alt="a">
                            </div>
                        </div>

                        <div class="item-tanggungan d-flex justify-content-between align-items-center"
                             v-for="(tanggungankasbon,idx) in datalisttanggungan.pembayaran_kasbon"
                             @click="editBayarKasbon(idx,tanggungankasbon)">
                            <div class="item-tanggungan--left">
                                <div class="f-14">{{tanggungankasbon.kasbon.keterangan}}</div>
                                <div class="f-12 f-c-midgrey">Kasbon •
                                    {{tanggungankasbon.kasbon.saldo | currency }}
                                </div>
                            </div>
                            <div class="item-tanggungan--right d-flex align-items-center">
                                <div class="f-14 m-r-12 f-c-red">
                                    {{tanggungankasbon.nominal.raw | currency}}
                                </div>
                                <img src="../../../assets/icons/edit_red.svg" alt="a">
                            </div>
                        </div>

                        <div class="separator-line-dot m-t-10"></div>

                        <div class="p-y-16 f-16 f-semi d-flex justify-content-between" v-if="subtotalTanggungan>0">
                            <div>Tanggungan Dibayar</div>
                            <div class="f-c-red">(-) {{subtotalTanggungan | currency}}</div>
                        </div>

                    </div>

                </div>

                <div class="separator"></div>

                <!-- TOTAL GAJI BERSIH -->
                <div class="m-t-16 p-x-20 w-limit">
                    <div class="f-16 f-bold d-flex justify-content-between">
                        <div class="d-flex">
                            <div>Total Gaji Bersih</div>
                            <img class="m-l-4" src="../../../assets/icons/checked-green.svg" alt="">
                        </div>
                        <div>{{ totalGaji | currency }}</div>
                    </div>
                    <div class="f-12 f-c-midgrey m-t-8">
                        Nominal akhir yang diterima karyawan setelah ditambah komisi dikurangi pembayaran tanggungan
                        (jika
                        ada).
                    </div>
                </div>

                <div class="button-wrapper p-x-20 p-y-20 w-limit w-100">
                    <div class="btn smart-primary" @click="godetailpembayaran">Berikutnya</div>
                </div>

            </div>

            <!-- MODAL -->
            <div class="modal fade" id="modaleditgaji" role="dialog">
                <div class="modal-dialog modal-lg bani-modal">
                    <div class="modal-content">
                        <div class="modal-head w-limit">
                            <div class="modal-head--left"></div>
                            <h5 class="f-16 f-bold">{{formGajiFaktur.text}}</h5>
                            <div class="modal-head--right" data-dismiss="modal">
                                <img src="../../../assets/img/x2.svg" alt="">
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="modal-bodyy w-limit w-100 p-x-20">

                            <label for="form1" class="m-t-16 form-label">Nominal</label>
                            <div class="input-group--inline m-d-16">
                                <InputRupiah
                                        :outerDivClass="'input-group mod'"
                                        v-model="formGajiFaktur.nominal"
                                        innerDivClass="input-group-prepend"
                                        :showRp="true"
                                        :defaultValue="formGajiFaktur.nominal.formatted"
                                />

                                <div class="input-group-middle multiply">x</div>
                                <div class="input-group mod">
                                    <input type="text" class="form-control" placeholder=".." :a="formGajiFaktur.type"
                                           v-model="formGajiFaktur.periode"
                                           :readonly="(formGajiFaktur.type===3 ? false: 'readonly')">
                                    <div class="input-group-append">
                                        <span class="input-group-text">{{(formGajiFaktur.type===1 ? 'Periode' : (formGajiFaktur.type===2 ? 'Hadir' : 'Jam'))}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="separator-line-dot"></div>
                            <div class="f-c-red" style="font-size:12px;">
                                * Untuk mengubah jumlah hadir, klik link edit kehadiran (dihalaman ini,bagian atas)
                            </div>

                            <div class="m-t-12 f-16 d-flex justify-content-between">
                                <div>Jumlah</div>
                                <div class="f-14 m-r-12">{{formGajiFaktur.nominal.raw*formGajiFaktur.periode |
                                    currency}}
                                </div>
                            </div>

                            <div class="button-wrapper p-t-12 p-d-20 w-limit w-100">
                                <button class="btn smart-primary" @click="saveGajiFaktur">Simpan</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- KOMISI -->
            <div class="modal fade" id="komisi-edit" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-head w-limit">
                            <div class="modal-head--left"></div>
                            <h5 class="f-16 f-bold">Ubah Komisi</h5>
                            <div class="modal-head--right" data-dismiss="modal">
                                <img src="../../../assets/img/x2.svg" alt="">
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="modal-bodyy w-limit w-100 p-x-20">

                            <div class="m-t-16">

                                <div class="form-group mod">
                                    <label for="form12" class="form-label">Nama Komisi</label>
                                    <input type="text" id="form12" class="form-control" placeholder="Nama komisi..."
                                           value="Komisi Sprei">
                                </div>

                                <label for="form2" class="m-t-16 form-label">Nominal</label>
                                <div class="input-group mod">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Rp</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="123.456" id="form2"
                                           value="220.000">
                                </div>

                                <div class="button-wrapper d-flex m-t-4 p-y-20 w-limit w-100">
                                    <div class="btn smart-secondary red m-r-10">Hapus</div>
                                    <div class="btn smart-primary">Simpan</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="komisi_add" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-head w-limit">
                            <div class="modal-head--left"></div>
                            <h5 class="f-16 f-bold">{{(formKomisiCustom.idx<0 ? "Tambah Komisi" : "Ubah Komisi")}}</h5>
                            <div class="modal-head--right" data-dismiss="modal">
                                <img src="../../../assets/img/x2.svg" alt="">
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="modal-bodyy w-limit w-100 p-x-20">

                            <div class="m-t-16">

                                <div class="form-group mod">
                                    <label for="form12" class="form-label">Nama Komisi</label>
                                    <input type="text" id="inputkomisi_add" class="form-control"
                                           placeholder="Nama komisi..." v-model="formKomisiCustom.nama">
                                    <ErrorMessage class="error" label="Nama Komisi"
                                                  :validation="$v.formKomisiCustom.nama"></ErrorMessage>

                                </div>

                                <div>

                                    <label for="form2" class="m-t-16 form-label">Nominal</label>
                                    <InputRupiah
                                            :outerDivClass="'input-group mod'"
                                            v-model="formKomisiCustom.nominal"
                                            innerDivClass="input-group-prepend"
                                            :showRp="true"
                                            :id="'form2'"
                                            :defaultValue="formKomisiCustom.nominal.formatted"
                                    />
                                    <ErrorMessage class="error" label="Nominal"
                                                  :validation="$v.formKomisiCustom.nominal.formatted"></ErrorMessage>
                                </div>


                                <div class="button-wrapper d-flex m-t-4 p-y-20 w-limit w-100">
                                    <div class="btn smart-primary" @click="saveKomisiCustom">Simpan</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- MODAL TANGGUNGAN POTONGAN -->
            <div class="modal fade" id="modal_edit_bayar_potongan" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-head w-limit">
                            <div class="modal-head--left"></div>
                            <h5 class="f-16 f-bold">Pembayaran Potongan</h5>
                            <div class="modal-head--right" data-dismiss="modal">
                                <img src="../../../assets/img/x2.svg" alt="">
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="modal-bodyy w-limit w-100 p-x-20">
                            <div class="p-y-16">
                                <div class="f-16 f-semi m-d-4">{{potongan.keterangan}}</div>
                                <div class="f-16">{{ potongan.saldo | currency()}}</div>
                            </div>
                            <div class="separator-line-dot"></div>
                            <div class="m-t-16">

                                <label class="form-label">Jenis Pembayaran</label>
                                <div class="radio-group">
                                    <div class="radio-wrapper">
                                        <div class="radio-item">
                                            <input type="radio" id="potonganbayarlunas" :value="1"
                                                   name="radioboxxpotonganbayar"
                                                   v-model="formPotongan.type">
                                            <label for="potonganbayarlunas">Lunas</label>
                                        </div>
                                        <div class="radio-item">
                                            <input type="radio" id="potonganbayarcicil" :value="2"
                                                   name="radioboxxpotonganbayar"
                                                   v-model="formPotongan.type">
                                            <label for="potonganbayarcicil">Cicilan</label>
                                        </div>
                                    </div>
                                </div>

                                <label class="m-t-16 form-label">Nominal</label>
                                <InputRupiah
                                        :style="(formPotongan.type===2) ? '' : 'display: none'"
                                        :outerDivClass="'input-group mod'"
                                        v-model="formPotongan.nominal"
                                        innerDivClass="input-group-prepend"
                                        :showRp="true"
                                        :defaultValue="formPotongan.nominal.formatted"
                                />
                                <div class="input-group mod" v-if="formPotongan.type!==2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Rp</span>
                                    </div>
                                    <input type="text" class="form-control" id="inputsaldopotonganfaktur" disabled
                                           :value="newrupiahcreateepaymentnominal(potongan.saldo)">
                                </div>


                                <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                                    <button class="btn smart-primary" @click="saveBayarPotongan">Tambahkan</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL TANGGUNGAN KASBON -->
            <div class="modal fade" id="modal_edit_bayar_kasbon" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-head w-limit">
                            <div class="modal-head--left"></div>
                            <h5 class="f-16 f-bold">Pembayaran Kasbon</h5>
                            <div class="modal-head--right" data-dismiss="modal">
                                <img src="../../../assets/img/x2.svg" alt="">
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="modal-bodyy w-limit w-100 p-x-20">
                            <div class="p-y-16">
                                <div class="f-16 f-semi m-d-4">{{kasbon.keterangan}}</div>
                                <div class="f-16">{{ kasbon.saldo | currency()}}</div>
                            </div>
                            <div class="separator-line-dot"></div>
                            <div class="m-t-16">

                                <label class="form-label">Jenis Pembayaran</label>
                                <div class="radio-group">
                                    <div class="radio-wrapper">
                                        <div class="radio-item">
                                            <input type="radio" id="kasbonbayarlunas" :value="1"
                                                   name="radioboxxkasbonbayar"
                                                   v-model="formKasbon.type">
                                            <label for="kasbonbayarlunas">Lunas</label>
                                        </div>
                                        <div class="radio-item">
                                            <input type="radio" id="kasbonbayarcicil" :value="2"
                                                   name="radioboxxkasbonbayar"
                                                   v-model="formKasbon.type">
                                            <label for="kasbonbayarcicil">Cicilan</label>
                                        </div>
                                    </div>
                                </div>

                                <label class="m-t-16 form-label">Nominal</label>
                                <InputRupiah
                                        :style="(formKasbon.type===2) ? '' : 'display: none'"
                                        :outerDivClass="'input-group mod'"
                                        v-model="formKasbon.nominal"
                                        innerDivClass="input-group-prepend"
                                        :showRp="true"
                                        :defaultValue="formKasbon.nominal.formatted"
                                />
                                <div class="input-group mod" v-if="formKasbon.type!==2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Rp</span>
                                    </div>
                                    <input type="text" class="form-control" id="inputsaldokasbonfaktur" disabled
                                           :value="newrupiahcreateepaymentnominal(kasbon.saldo)">
                                </div>


                                <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                                    <button class="btn smart-primary" @click="saveBayarKasbon">Tambahkan</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL KETERLAMBATAN -->
            <div class="modal fade" id="modal_edit_bayar_terlambat" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-head w-limit">
                            <div class="modal-head--left"></div>
                            <h5 class="f-16 f-bold">Keterlambatan</h5>
                            <div class="modal-head--right" data-dismiss="modal">
                                <img src="../../../assets/img/x2.svg" alt="">
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="modal-bodyy w-limit w-100 p-x-20">

                            <div class="m-t-16">

                                <div v-if="formTerlambat.with_absen">
                                    <label for="form1" class="m-t-16 form-label">Masuk Kerja</label>
                                    <InputRupiah

                                            :outerDivClass="'input-group mod'"
                                            v-model="formTerlambat.durasi_masuk"
                                            innerDivClass="input-group-prepend"
                                            :showRp="true"
                                            showRpPosition="right"
                                            showRpText="Hari"
                                            :id="'form1'"
                                            :defaultValue="formTerlambat.durasi_masuk.formatted"
                                            placeholder="Contoh : 30 hari"/>


                                </div>

                                <label for="form2" class="m-t-16 form-label">Durasi Terlambat</label>
                                <InputRupiah
                                        :outerDivClass="'input-group mod'"
                                        v-model="formTerlambat.durasi_keterlambatan"
                                        innerDivClass="input-group-prepend"
                                        :showRp="true"
                                        showRpPosition="right"
                                        showRpText="Menit"
                                        :id="'form2'"
                                        :defaultValue="formTerlambat.durasi_keterlambatan.formatted"
                                        :placeholder="15"/>


                                <label for="form3" class="m-t-16 form-label">Nominal Denda</label>
                                <InputRupiah
                                        :outerDivClass="'input-group mod'"
                                        v-model="formTerlambat.nominal_keterlambatan"
                                        innerDivClass="input-group-prepend"
                                        :showRp="true"
                                        :id="'form3'"
                                        :defaultValue="formTerlambat.nominal_keterlambatan.formatted"
                                        :placeholder="100.000"/>

                                <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">

                                    <!--                                <div class="button-wrapper d-flex m-t-4 p-y-20 w-limit w-100">-->
                                    <!--                                    <button class="btn smart-secondary red m-r-10">Hapus</button>-->
                                    <button class="btn smart-primary" @click="saveBayarTerlambat">Simpan</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ListTanggungan v-bind:class="{hidesection: !isSetTanggungan}" ref="settanggungan"
                        v-on:back="islisttanggungan" v-bind:datalisttanggungan="datalisttanggungan"
                        v-bind:datalisttanggungan_absen="datafakturgaji"/>
        <DetailPembayaran v-bind:class="{hidesection: !isSetDetailPembayaran}" ref="setdetailpembayaran"
                          v-on:back="isdetailpembayaran" :item-biaya="itemBiaya" v-on:goshowhistory="goshowhistory"/>

    </div>

	<DetailUpahBorongan v-if="showDetailUpahBorongan" @back="backDetailUpahBorongan" :data="dataFakturGajiRes"/>
	</div>

</template>

<script>
    import ListTanggungan from "./ListTanggungan";
    import ErrorMessage from "@/component-items/ErrorMessage";
    import InputRupiah from "@/component-items/InputRupiah";
    import {maxLength, minLength, required} from "vuelidate/lib/validators";
    import DetailPembayaran from "./DetailPembayaran";
    import DetailUpahBorongan from "@/components/penggajian/Faktur Gaji/DetailUpahBorongan";

    export default {
        name: "FakturGaji",
        props: ['databayargaji', 'datafakturgaji', 'datadetailabsen'],
        components: {DetailPembayaran, ListTanggungan, ErrorMessage, InputRupiah, DetailUpahBorongan},
        data() {
            return {
                isSetTanggungan: false,
                isSetDetailPembayaran: false,
                DataGajiFaktur: [],
                formGajiFaktur: {
                    idx: -1,
                    id: 0,
                    periode: 0,
                    type: 0,
                    text: "",
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                },
                itemBiaya: [],

                SetLate: 0,
                payment: 0,
                keynonaktif: 0,
                namagaji: '',
                input_kehadiran: 0,
                input_jam: 0,
                mominalGaji_modal: 0,
                type_periode: '',
                type_gaji: 0,
                input_periode: 0,

                dataUpahTahapan: [],
                total_upah: 0,

                status_tanggungan: 0,
                Persentasekomisi_Faktur: 0,

                nominal_tanggungan: 0,


                //modal edit keterlambatan
                total_keterlambatan_tanggungan: 0,
                nominal_keterlambatan_tanggungan: 0,
                durasi_keterlambatan_tanggungan: 0,


                //modal edit kasbon
                namakasbon_tanggungan: '',
                ket_kasbon_nominal_tanggungan: '',
                ket_saldokasbon_totalnominal: '',
                nominal_lunas_kasbon_tanggungan: 0,
                nominal_lunas_kasbon_tanggunganStr: '',
                nominal_cicil_kasbon_tanggungan: 0,
                tipe_kasbon_tanggunag: 1,
                total_tanggungan_kasbon: 0,

                //modal edit potongan
                namapotongan_tanggungan: '',
                ket_potongan_nominal_tanggungan: '',
                ket_saldopotongan_totalnominal: '',
                nominal_lunas_potongan_tanggungan: 0,
                nominal_lunas_potongan_tanggunganStr: '',
                nominal_cicil_potongan_tanggungan: 0,
                tipe_potongan_tanggunag: 1,
                total_tanggungan_potongan: 0,


                payment_modal_edit_periode: '',
                total_tanggungan_late: 0,

                nominal_gaji_index: 0,
                hasil_nominal_dan_periode: 0,
                nominalakhir: 0,

                //modal komisi custom
                dataKomisiCustom: [],
                formKomisiCustom: {
                    idx: -1,
                    nama: "",
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                },

                kasbon: {
                    id: "",
                    keterangan: "",
                    saldo: ""
                },

                formKasbon: {
                    idx: -1,
                    type: 0,
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                },

                potongan: {
                    id: "",
                    keterangan: "",
                    saldo: ""
                },
                formPotongan: {
                    idx: -1,
                    type: 0,
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                },

                formTerlambat: {
                    with_absen: false,
                    durasi_keterlambatan: {
                        formatted: "",
                        raw: 0
                    },
                    nominal_keterlambatan: {
                        formatted: "",
                        raw: 0
                    },
                    durasi_masuk: {
                        formatted: "",
                        raw: 0
                    },
                },

                datalisttanggungan: {
                    potonganfaktur: [],
                    kasbonfaktur: [],
                    pembayaran_kasbon: [],
                    pembayaran_potongan: [],
                    // nominal_tanggungan_fix:0,
                    status_tanggungan_faktur: 1,
                },

                komisiSales: {},

                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	            showDetailUpahBorongan: false,

	            dataFakturGajiRes: {}
            }
        },
        computed: {
            subtotalGaji() {
                let subtotalGaji = 0;
                subtotalGaji += this.DataGajiFaktur.reduce((sum, listGaji) => {
                    var nominal = 0;
                    if (listGaji.type === 1) {
                        nominal = listGaji.nominal;
                    } else if (listGaji.type === 2) {
                        nominal = listGaji.nominal * this.datafakturgaji.masuk_kerja_Faktur;
                    } else if (listGaji.type === 3) {
                        nominal = listGaji.nominal * listGaji.periode;
                    }

                    return sum += nominal;
                }, 0);

                return subtotalGaji;

            },
            subtotalKomisi() {
                let subtotalKomisi = 0;
                subtotalKomisi += this.dataKomisiCustom.reduce((sum, komisiCustom) => {
                    return sum += komisiCustom.nominal.raw;
                }, 0);
                subtotalKomisi += this.komisiSales.komisi;
                return subtotalKomisi;
            },
            subtotalUpahTahapn() {
                let subtotalUpah = 0;
                subtotalUpah += this.dataUpahTahapan.reduce((sum, upahTahapan) => {
                    return sum += upahTahapan.total_gaji;
                }, 0);

                return subtotalUpah;
            },
            subtotalTanggungan() {
                let subtotalTanggungan = 0;
                subtotalTanggungan += this.datalisttanggungan.pembayaran_kasbon.reduce((sum, kasbon) => {
                    return sum += kasbon.nominal.raw;
                }, 0);
                subtotalTanggungan += this.datalisttanggungan.pembayaran_potongan.reduce((sum, potongan) => {
                    return sum += potongan.nominal.raw;
                }, 0);
                subtotalTanggungan += this.datadetailabsen.nominal_keterlambatan.raw;
                return subtotalTanggungan;
            },
            totalGaji() {
                return this.subtotalGaji + this.subtotalKomisi + this.subtotalUpahTahapn - this.subtotalTanggungan
            },
            totalGajiKotor() {
                return this.subtotalGaji + this.subtotalKomisi + this.subtotalUpahTahapn
            }
        },
        mounted() {
            // this.DataFakturGaji();
            // this.ListKasbonFaktur();
            // this.ListPotonganFaktur();
	        this.initData()

            this.backButtonPressed(this.backtobayargaji)
        },

        watch: {
            'datafakturgaji.masuk_kerja_Faktur': {
                handler: function (a) {
                    // alert('dd'+a);
                },
                deep: true,
                immediate: true
            },
        },
        validations: {
            formKomisiCustom: {
                nama: {
                    required,
                    minLength: minLength(2),
                },
                nominal: {
                    formatted: {
                        required,
                        minLength: minLength(1),
                    }
                },
            }
        },
        methods: {
        	async initData() {
		        $('#loadingPage2').addClass('overlayLoading');
		        $('#loadingPage2').show();

		        await this.DataFakturGaji();
		        await this.ListKasbonFaktur();
		        await this.ListPotonganFaktur();

		        $('#loadingPage2').hide();
		        $('#loadingPage2').removeClass('overlayLoading');
	        },

            editGajiFaktur(gaji, index) {
                this.formGajiFaktur = {
                    idx: index,
                    id: gaji.id,
                    periode: (gaji.type === 2 ? this.datafakturgaji.masuk_kerja_Faktur : parseFloat(gaji.periode)),
                    type: gaji.type,
                    text: gaji.text,
                    nominal: {
                        raw: gaji.nominal,
                        formatted: this.newrupiahcreateepaymentnominal(gaji.nominal.toString())
                    }
                };

                $('#modaleditgaji').modal('show')
            },

            saveGajiFaktur() {

                let newGajiFaktur = this.DataGajiFaktur[this.formGajiFaktur.idx];
                newGajiFaktur.nominal = this.formGajiFaktur.nominal.raw;
                newGajiFaktur.periode = this.formGajiFaktur.periode;

                this.DataGajiFaktur[this.formGajiFaktur.idx] = newGajiFaktur;
                this.$set(this.formGajiFaktur, this.formGajiFaktur.idx, newGajiFaktur);

                $('#modaleditgaji').modal('hide');
            },

            editKomisiCustom(idx, komisiCustom) {
                this.formKomisiCustom.idx = idx;
                this.formKomisiCustom.nama = komisiCustom.nama;
                this.formKomisiCustom.nominal.raw = komisiCustom.nominal.raw;
                this.formKomisiCustom.nominal.formatted = komisiCustom.nominal.formatted;
                $("#komisi_add").modal("show");

            },
            addKomisiCustom() {
                this.formKomisiCustom = {
                    idx: -1,
                    nama: "",
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                };
                $("#komisi_add").modal("show");
            },
            saveKomisiCustom() {
                this.$v.formKomisiCustom.nama.$touch()
                this.$v.formKomisiCustom.nominal.formatted.$touch()
                if (this.$v.formKomisiCustom.nama.$invalid || this.$v.formKomisiCustom.nominal.formatted.$invalid) {
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }
                $("#komisi_add").modal("hide");
                var newCustomKomisi = {
                    nama: this.formKomisiCustom.nama,
                    nominal: {
                        raw: this.formKomisiCustom.nominal.raw,
                        formatted: this.formKomisiCustom.nominal.formatted
                    }
                };

                if (this.formKomisiCustom.idx < 0) {
                    this.dataKomisiCustom.push(newCustomKomisi);
                } else {
                    this.dataKomisiCustom[this.formKomisiCustom.idx] = newCustomKomisi;
                    this.$set(this.dataKomisiCustom, this.formKomisiCustom.idx, newCustomKomisi);
                }

                this.formKomisiCustom = {
                    idx: -1,
                    nama: "",
                    nominal: {
                        raw: 0,
                        formatted: ""
                    }
                };

            },

            /* tanggungan*/

            editBayarKasbon(idx, bayarkasbon) {
                this.kasbon = bayarkasbon.kasbon
                this.formKasbon.idx = idx;
                this.formKasbon.type = bayarkasbon.type;
                this.formKasbon.nominal.raw = bayarkasbon.nominal.raw;
                this.formKasbon.nominal.formatted = bayarkasbon.nominal.formatted;
                $('#modal_edit_bayar_kasbon').modal('show');

            },
            saveBayarKasbon() {
                if (this.formKasbon.type === 2) {
                    if (this.formKasbon.nominal.raw > this.kasbon.saldo) {
                        this.$toast.error("Pembayaran kasbon tidak boleh melebihi sisa kasbon.")
                        return
                    }
                }

                let pembayaran_kasbon = {
                    kasbon: this.kasbon,
                    type: this.formKasbon.type,
                    nominal: {
                        raw: (this.formKasbon.type === 2) ? this.formKasbon.nominal.raw : this.kasbon.saldo,
                        formatted: (this.formKasbon.type === 2) ? this.formKasbon.nominal.formatted : this.newrupiahcreateepaymentnominal(this.kasbon.saldo)
                    },
                    status: 1,
                };

                this.datalisttanggungan.pembayaran_kasbon[this.formKasbon.idx] = pembayaran_kasbon;
                this.$set(this.datalisttanggungan.pembayaran_kasbon, this.formKasbon.idx, pembayaran_kasbon);

                $('#modal_edit_bayar_kasbon').modal('hide');

            },

            editBayarPotongan(idx, bayarpotongan) {
                this.potongan = bayarpotongan.potongan
                this.formPotongan.idx = idx;
                this.formPotongan.type = bayarpotongan.type;
                this.formPotongan.nominal.raw = bayarpotongan.nominal.raw;
                this.formPotongan.nominal.formatted = bayarpotongan.nominal.formatted;
                $('#modal_edit_bayar_potongan').modal('show');

            },
            saveBayarPotongan() {
                if (this.formPotongan.type === 2) {
                    if (this.formPotongan.nominal.raw > this.potongan.saldo) {
                        this.$toast.error("Pembayaran potongan tidak boleh melebihi sisa potongan.")
                        return
                    }
                }

                let pembayaran_potongan = {
                    potongan: this.potongan,
                    type: this.formPotongan.type,
                    nominal: {
                        raw: (this.formPotongan.type === 2) ? this.formPotongan.nominal.raw : this.potongan.saldo,
                        formatted: (this.formPotongan.type === 2) ? this.formPotongan.nominal.formatted : this.newrupiahcreateepaymentnominal(this.potongan.saldo)
                    },
                    status: 1,
                };

                this.datalisttanggungan.pembayaran_potongan[this.formPotongan.idx] = pembayaran_potongan;
                this.$set(this.datalisttanggungan.pembayaran_potongan, this.formPotongan.idx, pembayaran_potongan);

                $('#modal_edit_bayar_potongan').modal('hide');

            },

            // <!-- MODAL TANGGUNGAN KETERLAMBATAN -->
            editBayarTerlambat(withAbsen) {
                if (withAbsen === true) {
                    this.formTerlambat.durasi_masuk.raw = this.datafakturgaji.masuk_kerja_Faktur
                    this.formTerlambat.durasi_masuk.formatted = this.newrupiahcreateepaymentnominal(this.datafakturgaji.masuk_kerja_Faktur)
                }
                this.formTerlambat.with_absen = withAbsen;
                this.formTerlambat.nominal_keterlambatan = this.datadetailabsen.nominal_keterlambatan;
                this.formTerlambat.durasi_keterlambatan = this.datadetailabsen.durasi_keterlambatan;
                $('#modal_edit_bayar_terlambat').modal('show');
            },


            saveBayarTerlambat() {
                if (this.formTerlambat.with_absen === true) {
                    this.datafakturgaji.masuk_kerja_Faktur = this.formTerlambat.durasi_masuk.raw
                }
                this.datadetailabsen.nominal_keterlambatan.raw = this.formTerlambat.nominal_keterlambatan.raw;
                this.datadetailabsen.nominal_keterlambatan.formatted = this.formTerlambat.nominal_keterlambatan.formatted;
                this.datadetailabsen.durasi_keterlambatan.raw = this.formTerlambat.durasi_keterlambatan.raw;
                this.datadetailabsen.durasi_keterlambatan.formatted = this.formTerlambat.durasi_keterlambatan.formatted;
                $('#modal_edit_bayar_terlambat').modal('hide');
            },

            islisttanggungan() {
                $('#FakturGaji').show();
                this.isSetTanggungan = false;
            },
            isdetailpembayaran() {
	            this.backButtonPressed(this.backtobayargaji)
                $('#FakturGaji').show();
                this.isSetDetailPembayaran = false;
            },

            gosettanggungan() {
                this.isSetTanggungan = true;
                $('#FakturGaji').hide();
            },
            godetailpembayaran() {
	            this.backButtonPressed(this.$refs.setdetailpembayaran.showfaktur)
                this.isSetDetailPembayaran = true;
                $('#FakturGaji').hide();
            },

            backtobayargaji() {
                this.$emit('backtobayargaji')
            },

            goshowhistory() {
                this.$emit('goshowhistory');
            },

            gotopreviewgaji() {
                this.$emit('gotopreview')
            },

            gotodetailehadiran() {
                this.$emit('gotodetailkehadiran')
            },

            newrupiahcreateepaymentnominal(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.toString().replace(/[^.\d]/g, ""),
                    split = number_string.split("."),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },


            async ListKasbonFaktur() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                this.datalisttanggungan.kasbonfaktur = [];
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_kasbon_karyawan?idkaryawan='
                        + this.databayargaji.selected_karyawan_Faktur
                        + '&limit=500'
                        , this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var DataKasbonFaktur = response.data.data;
                        for (var k = 0; k < DataKasbonFaktur.length; k++) {
                            this.datalisttanggungan.kasbonfaktur.push({
                                id: DataKasbonFaktur[k].IdKasbon,
                                keterangan: DataKasbonFaktur[k].Keterangan,
                                waktukasbon: DataKasbonFaktur[k].WaktuKasbon,
                                saldo: DataKasbonFaktur[k].Saldo,
                                status: 1,
                            });
                        }
                    }
                } catch (e) {
	                $('#loadingPage2').hide();
	                $('#loadingPage2').removeClass('overlayLoading');
                	this.backtobayargaji()
                    if (!e.code) {
                    	this.$toast.error("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti")
                        // $('#loadingPage').hide();
                        // $('#loadingPage').removeClass('overlayLoading');
                        // $('#alert').show()
                        // $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        // $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                        // $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                        // setTimeout(() => {
                        //     $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                        //     $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        //     setTimeout(() => {
                        //         $('#alert').addClass("display-none")
                        //     }, 2000)
                        // }, 30000)
                        if (e.response.status === 500) {
                        	this.$toast.error("e.response.data.msg")
                            // $('#loadingPage').hide();
                            // $('#loadingPage').removeClass('overlayLoading');
                            // $('#alert').show()
                            // $('#contentAlert').text(e.response.data.msg);
                            // $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                            // $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                            // setTimeout(() => {
                            //     $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                            //     $('#alert').addClass("alert alert-danger animated fadeOutUp");
                            //     setTimeout(() => {
                            //         $('#alert').addClass("display-none")
                            //     }, 2000)
                            // }, 30000)
                        }
                    }
                }
            },


            async ListPotonganFaktur() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                this.datalisttanggungan.potonganfaktur = [];
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/list_potongan_karyawan?idkaryawan='
                        + this.databayargaji.selected_karyawan_Faktur
                        + '&limit=500'
                        , this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var DataPotonganFaktur = response.data.data.RekapPotongan;
                        console.log(DataPotonganFaktur)
                        for (var p = 0; p < DataPotonganFaktur.length; p++) {
                            this.datalisttanggungan.potonganfaktur.push({
                                id: DataPotonganFaktur[p].IdPotongan,
                                keterangan: DataPotonganFaktur[p].Keterangan,
                                waktupotongan: DataPotonganFaktur[p].WaktuPotongan,
                                saldo: DataPotonganFaktur[p].Saldo,

                                status: 1,
                            });
                        }
                    }
                } catch (e) {
	                $('#loadingPage2').hide();
	                $('#loadingPage2').removeClass('overlayLoading');
                	this.backtobayargaji()
                    if (!e.code) {
                    	this.$toast.error("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti")
                        // $('#loadingPage').hide();
                        // $('#loadingPage').removeClass('overlayLoading');
                        // $('#alert').show()
                        // $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        // $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                        // $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                        // setTimeout(() => {
                        //     $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                        //     $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        //     setTimeout(() => {
                        //         $('#alert').addClass("display-none")
                        //     }, 2000)
                        // }, 30000)
                        if (e.response.status === 500) {
                        	this.$toast.error(e.response.data.msg)
                            // $('#loadingPage').hide();
                            // $('#loadingPage').removeClass('overlayLoading');
                            // $('#alert').show()
                            // $('#contentAlert').text(e.response.data.msg);
                            // $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                            // $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                            // setTimeout(() => {
                            //     $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                            //     $('#alert').addClass("alert alert-danger animated fadeOutUp");
                            //     setTimeout(() => {
                            //         $('#alert').addClass("display-none")
                            //     }, 2000)
                            // }, 30000)
                        }
                    }
                }
            },


            async DataFakturGaji() {
                this.datadetailabsen.durasi_keterlambatan = {
                    formatted: "",
                    raw: 0
                };
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                this.DataGajiFaktur = [];
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/data_faktur_gaji?idkaryawan='
                        + this.databayargaji.selected_karyawan_Faktur + '&tanggal_mulai=' + this.databayargaji.input_date_awal_Faktur
                        + '&tanggal_selesai=' + this.databayargaji.input_date_akhir_Faktur, this.requestHeaders);
                    if (response.data.status === true) {
                        this.DataGajiFaktur = [];
                        this.dataFakturGajiRes = response.data.data

                        // this.setmasukaktif();
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        var DataKaryawanGaji = response.data.data;
                        var DataGajiArray = DataKaryawanGaji.pengaturans;

                        this.itemBiaya = DataKaryawanGaji.biaya_items;
                        var DataKaryawan = DataKaryawanGaji.karyawan;
                        var DataKomisi = DataKaryawanGaji.komisi_sales;
                        var DataUpah = DataKaryawanGaji.upah_tahapan;
                        this.komisiSales = DataKaryawanGaji.komisi_sales;
                        this.status_tanggungan = DataKaryawanGaji.tanggungan.status;
                        this.nominal_tanggungan = DataKaryawanGaji.tanggungan.total_nominal;

                        for (var i = 0; i < DataGajiArray.length; i++) {
                            this.DataGajiFaktur.push({
                                id: DataGajiArray[i].jenis_gaji.id,
                                text: DataGajiArray[i].jenis_gaji.nama,
                                type: DataGajiArray[i].jenis_gaji.type,
                                nominal: DataGajiArray[i].nominal,
                                periode: (DataGajiArray[i].jenis_gaji.type === 1 ? 1 : (DataGajiArray[i].jenis_gaji.type === 2 ? this.datafakturgaji.masuk_kerja_Faktur : 0)),
                            });
                        }

                        this.dataUpahTahapan = [];
                        for (var u = 0; u < DataUpah.length; u++) {
                            this.dataUpahTahapan.push({
                                nama_tahapan: DataUpah[u].nama_tahapan,
                                idtahapan: DataUpah[u].idtahapan,
                                total_gaji: DataUpah[u].total_gaji,
                                kauntitas_tahapan: DataUpah[u].satuan_kuantitas.length,
                            });
                        }
                    }
                } catch (e) {
	                $('#loadingPage2').hide();
	                $('#loadingPage2').removeClass('overlayLoading');
                	this.backtobayargaji()
                    if (!e.code) {
                    	this.$toast.error("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti")
                        // $('#loadingPage').hide();
                        // $('#loadingPage').removeClass('overlayLoading');
                        // $('#alert').show()
                        // $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        // $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                        // $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                        // setTimeout(() => {
                        //     $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                        //     $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        //     setTimeout(() => {
                        //         $('#alert').addClass("display-none")
                        //     }, 2000)
                        // }, 30000)
                        if (e.response.status === 500) {
                        	this.$toast.error(e.response.data.msg)
                            // $('#loadingPage').hide();
                            // $('#loadingPage').removeClass('overlayLoading');
                            // $('#alert').show()
                            // $('#contentAlert').text(e.response.data.msg);
                            // $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                            // $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                            // setTimeout(() => {
                            //     $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                            //     $('#alert').addClass("alert alert-danger animated fadeOutUp");
                            //     setTimeout(() => {
                            //         $('#alert').addClass("display-none")
                            //     }, 2000)
                            // }, 30000)
                        }
                    }
                }
            },
	        lihatDetailUpahBorongan() {
            	$("#faktur-gaji").hide()
		        this.showDetailUpahBorongan = true
	        },
	        backDetailUpahBorongan() {
		        $("#faktur-gaji").show()
		        this.showDetailUpahBorongan = false

		        this.DataFakturGaji();
		        this.ListKasbonFaktur();
		        this.ListPotonganFaktur();
	        }
        }
    }
</script>

<style>
    .item-gaji,
    .item-komisi,
    .item-tanggungan {
        margin-left: -20px;
        margin-right: -20px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 6px;
        padding-bottom: 6px;
    }

    .item-gaji:hover,
    .item-komisi:hover,
    .item-tanggungan:hover {
        background: rgba(0, 0, 0, 0.05);
    }

    .detail-absensi {
        display: flex;
        flex-wrap: wrap;
    }

    .detail-absensi div:not(:last-child):after {
        content: ', \00a0';
    }

    .f-c-green {
        color: #00bd29;
    }
</style>